import { Box, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type WCValueTooltipType = 'salary' | 'workingCondition'

interface GetTooltipLabelProps {
  type: WCValueTooltipType
  linked: boolean
  workingConditionName?: string
}

const getTooltipLabel = ({
  type,
  linked,
  workingConditionName,
}: GetTooltipLabelProps): string | undefined => {
  switch (type) {
    case 'salary':
      return linked
        ? i18n.t(
            'add_employee_modal.contract_information_step.alerts.salary_amount_matching_salary_range.linked'
          )
        : i18n.t(
            'add_employee_modal.contract_information_step.alerts.salary_amount_matching_salary_range.unlinked'
          )
    case 'workingCondition':
      return linked
        ? i18n.t(
            'add_employee_modal.contract_information_step.alerts.working_condition_value_tooltip.linked',
            {
              workingConditionName,
            }
          )
        : i18n.t(
            'add_employee_modal.contract_information_step.alerts.working_condition_value_tooltip.unlinked',
            {
              workingConditionName,
            }
          )
    default:
      return undefined
  }
}

interface Props {
  linked: boolean
  type: WCValueTooltipType
  onClick: () => void
  workingConditionName?: string
}

const MatchingValueTooltip = ({ linked, onClick, workingConditionName, type }: Props) => {
  const [open, toggle] = useToggle(false)
  const label = getTooltipLabel({ type, linked, workingConditionName })

  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={label}>
      <Box onClick={!linked ? onClick : undefined}>
        <Icon.Medium
          icon={linked ? 'link' : 'link-remove'}
          color={linked ? 'feedbackIconInfo' : 'feedbackIconWarning'}
        />
      </Box>
    </Tooltip.Alt>
  )
}

export default MatchingValueTooltip
